import React, { useEffect, useState } from "react";
import { Dropdown, Menu, Tag } from "antd";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import styles from "./styles/UserMenu.scss";
import { IndexAvatar } from "../../components/IndexAvatar";
import { PageRoute } from "../../models/enums";
import { selectUnreadCount } from "../../routes/Chat/chat.ducks";
import { selectSystemMessageUnreadCount } from "../../routes/SystemMessage/systemMessage.ducks";

function LoggedInMenu({ user, handleLogout }) {
  const chatUnreadCount = useSelector(selectUnreadCount);
  const systemUnreadCount = useSelector(selectSystemMessageUnreadCount);
  const unreadCount = (chatUnreadCount || 0) + (systemUnreadCount || 0);
  
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", offDropdown);
    return () => {
      window.removeEventListener("scroll", offDropdown);
    };
  }, []);

  const offDropdown = () => {
    setVisible(false);
  };

  const handleVisibleChange = (visible: any) => {
    setVisible(visible);
  };

  return (
    <Dropdown
      visible={visible}
      onVisibleChange={handleVisibleChange}
      placement="bottomRight"
      // @ts-ignore
      overlayClassName={styles.userDropdown}
      overlay={
        <Menu>
          <div className={styles.callout}></div>
          <Menu.Item className={styles.menuItem}>
            <Link
              title={"Moji oglasi"}
              className={styles.userMenuText}
              to={PageRoute.myAd}
              rel="noopener noreferrer nofollow"
            >
              {"Moji oglasi"}
            </Link>
          </Menu.Item>

          <Menu.Item className={styles.menuItem}>
            <Link
              title={"Poruke"}
              className={styles.userMenuText}
              to={PageRoute.chats}
              rel="noopener noreferrer nofollow"
            >
              {"Poruke"}
              {unreadCount > 0 && (
                <Tag className={styles.tag}>
                  {unreadCount}
                </Tag>
              )}
            </Link>
          </Menu.Item>

          <Menu.Item className={styles.menuItem}>
            <Link
              title={"Ocjene"}
              className={styles.userMenuText}
              to={PageRoute.myRatings}
            >
              {"Ocjene"}
            </Link>
          </Menu.Item>
          <Menu.Item className={styles.menuItem}>
            <Link
              title={"Spremljeni oglasi"}
              className={styles.userMenuText}
              to={PageRoute.favorite}
              rel="noopener noreferrer nofollow"
            >
              {"Spremljeni oglasi"}
            </Link>
          </Menu.Item>
          <Menu.Item className={styles.menuItem}>
            <Link
              title={"Moje pretrage"}
              className={styles.userMenuText}
              to={PageRoute.savedSearch}
              rel="noopener noreferrer nofollow"
            >
              {"Moje pretrage"}
            </Link>
          </Menu.Item>
          <Menu.Item className={styles.menuItem}>
            <Link
              title={"Financije"}
              className={styles.userMenuText}
              to={PageRoute.finance}
              rel="noopener noreferrer nofollow"
            >
              {"Financije"}
            </Link>
          </Menu.Item>

          <Menu.Item className={styles.menuItem}>
            <Link
              title={"Krediti"}
              className={styles.userMenuText}
              to={PageRoute.credits}
              rel="noopener noreferrer nofollow"
            >
              {"Krediti"}
              <Tag className={styles.tag}>
                {user.storeCreditBalance}
              </Tag>
            </Link>
          </Menu.Item>
          <Menu.Item className={styles.menuItem}>
            <Link
              title={"Moji podaci"}
              className={`${styles.userMenuText}`}
              to={PageRoute.profile}
              rel="noopener noreferrer nofollow"
            >
              {"Moji podaci"}
            </Link>
          </Menu.Item>
          <Menu.Item className={styles.menuItem}>
            <Link
              title={"Postavke"}
              className={styles.userMenuText}
              to={PageRoute.settings}
              rel="noopener noreferrer nofollow"
            >
              {"Postavke"}
            </Link>
          </Menu.Item>
          <Menu.Item className={styles.menuItem}>
            <a
              className={styles.userMenuText}
              rel="noopener noreferrer"
              role="presentation"
              onClick={handleLogout}
              title={"Odjava"}
            >
              {"Odjava"}
            </a>
          </Menu.Item>
        </Menu>
      }
    >
      <span>
        <IndexAvatar className={`${styles.avatar} ${visible ? styles.highlighted : ""}`} url={user.avatar} />
      </span>
    </Dropdown>
  );
}

export default React.memo(LoggedInMenu);



// WEBPACK FOOTER //
// ./src/containers/UserMenu/LoggedInMenu.tsx